import { Vector2 } from '../utils/Vector2';
import { GAME_CONSTANTS } from '../utils/Constants';
import { Tile, TileType, MapData } from '../types/GameTypes';

export class SPMapGenerator {
  static generate(): MapData {
    // Create a clean 20x20 map for 1080p single-player
    const arenaSize = 20;
    const worldSize = arenaSize; // No borders, just the arena

    // Create empty 20x20 grid
    const grid: Tile[][] = [];
    for (let y = 0; y < worldSize; y++) {
      grid[y] = [];
      for (let x = 0; x < worldSize; x++) {
          grid[y][x] = { x, y, type: 'empty' };
        }
    }

    // Place spawn and goal with good distance (opposite corners for guaranteed path)
    // Spawn at top-left area, goal at bottom-right area
    const spawn = { x: 2, y: 2 }; // Top-left area with some margin
    const goal = { x: 17, y: 17 }; // Bottom-right area with some margin

    // Set spawn and goal tiles
    grid[spawn.y][spawn.x].type = 'spawn';
    grid[goal.y][goal.x].type = 'goal';

    // Apply 2-tile safety buffer around spawn (no building zone)
    for (let dy = -2; dy <= 2; dy++) {
      for (let dx = -2; dx <= 2; dx++) {
        const nx = spawn.x + dx;
        const ny = spawn.y + dy;
        if (nx >= 0 && nx < worldSize && ny >= 0 && ny < worldSize) {
          if (grid[ny][nx].type === 'empty') {
            // Keep empty but mark as protected (we'll check this during placement)
          }
        }
      }
    }

    // Apply 2-tile safety buffer around goal (no building zone)
    for (let dy = -2; dy <= 2; dy++) {
      for (let dx = -2; dx <= 2; dx++) {
        const nx = goal.x + dx;
        const ny = goal.y + dy;
        if (nx >= 0 && nx < worldSize && ny >= 0 && ny < worldSize) {
          if (grid[ny][nx].type === 'empty') {
            // Keep empty but mark as protected
          }
        }
      }
    }

    return {
      worldWidth: worldSize,
      worldHeight: worldSize,
      arenaWidth: arenaSize,
      arenaHeight: arenaSize,
      spawns: [new Vector2(spawn.x, spawn.y)],
      goals: [new Vector2(goal.x, goal.y)],
      grid,
    };
  }

  private static manhattanDistance(a: { x: number; y: number }, b: { x: number; y: number }): number {
    return Math.abs(a.x - b.x) + Math.abs(a.y - b.y);
  }
}

